import { c as _c } from "react/compiler-runtime";
import type { ComponentType } from 'react';
import type { SkeletonProps } from 'react-loading-skeleton';
import SkeletonBase from 'react-loading-skeleton';
import { baseColorSkeletonDark, baseColorSkeletonLight, highlightColorSkeletonDark, highlightColorSkeletonLight } from '../../shared/skeleton-colors';
import 'react-loading-skeleton/dist/skeleton.css';
const Skeleton = SkeletonBase as ComponentType<SkeletonProps>;
type TextSkeletonProps = {
  height?: number;
  width?: string | number;
  count?: number;
  dark?: boolean;
  className?: string;
};
export function TextSkeleton(t0) {
  const $ = _c(7);
  const {
    height: t1,
    width: t2,
    count: t3,
    dark: t4,
    className: t5
  } = t0;
  const height = t1 === undefined ? 30 : t1;
  const width = t2 === undefined ? "100%" : t2;
  const count = t3 === undefined ? 1 : t3;
  const dark = t4 === undefined ? false : t4;
  const className = t5 === undefined ? "" : t5;
  const baseColor = dark ? baseColorSkeletonDark : baseColorSkeletonLight;
  const highlightColor = dark ? highlightColorSkeletonDark : highlightColorSkeletonLight;
  let t6;
  if ($[0] !== baseColor || $[1] !== className || $[2] !== count || $[3] !== height || $[4] !== highlightColor || $[5] !== width) {
    t6 = <Skeleton height={height} width={width} baseColor={baseColor} highlightColor={highlightColor} count={count} borderRadius={16} className={className} />;
    $[0] = baseColor;
    $[1] = className;
    $[2] = count;
    $[3] = height;
    $[4] = highlightColor;
    $[5] = width;
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  return t6;
}